<div class="all-plans-include">
  <div class="all-plans-heading">All plans include...</div>
  <div class="all-plans-grid">
    <div class="all-plans-feature" *ngFor="let feature of features">
      <ng-icon [name]="'heroCheckCircle'" [strokeWidth]="'2'"></ng-icon>
      <span>{{ feature }}</span>
    </div>
  </div>
</div>
